import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';
import { consentTemplatesApiQueryKeys } from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.queryKeys.ts';
import { ConsentTemplateDto } from '@/features/dashboard/consentTemplates/types/ConsentTemplateDto.ts';

const useGetConsentTemplate = (id: string) => {
  return useQuery(getConsentTemplateQueryOptions(id));
};

export const getConsentTemplateQueryOptions = (
  id: string,
): UseQueryOptions<ConsentTemplateDto> => ({
  queryKey: consentTemplatesApiQueryKeys.byId(id),
  queryFn: () => consentTemplatesApi.get(id),
  enabled: id !== undefined,
});

export default useGetConsentTemplate;
